import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {useEffect, useRef, useState} from 'react'
import {useRouter} from 'next/router'
import type {Block} from '@/services/kontent-ai/types'

const READ_REVIEWS_TEXT_PATTERN = /^read(?:\s+\d[\d,]*)?\s+reviews?$/i

export type BazaarVoiceRatingsContentItem = IContentItem<{
	productId: Elements.TextElement
}>

export const BazaarVoiceRatingsBlock: Block<BazaarVoiceRatingsContentItem> = ({
	block,
}) => {
	const router = useRouter()
	const widgetRef = useRef<HTMLDivElement>(null)
	const [productId, setProductId] = useState(block.elements.productId)

	useEffect(() => {
		const sku =
			typeof router.query.sku === 'string' ? router.query.sku : undefined
		setProductId(sku || block.elements.productId)
	}, [router.query.sku, block.elements.productId])

	useEffect(() => {
		if (typeof window === 'undefined' || !widgetRef.current) return

		const removeReadReviewsCta = (): void => {
			widgetRef.current
				?.querySelectorAll('a, button')
				.forEach((element) => {
					const text =
						element.textContent?.replace(/\s+/g, ' ').trim() ?? ''

					if (READ_REVIEWS_TEXT_PATTERN.test(text)) {
						element.remove()
					}
				})
		}

		removeReadReviewsCta()

		const observer = new MutationObserver(() => {
			removeReadReviewsCta()
		})

		observer.observe(widgetRef.current, {
			childList: true,
			subtree: true,
		})

		return () => {
			observer.disconnect()
		}
	}, [productId])

	return (
		<div
			data-bv-product-id={productId}
			data-bv-show="rating_summary"
			data-kontent-element-codename="product_id"
			data-testid="bazaar-voice-ratings-widget"
			ref={widgetRef}
		/>
	)
}
